var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeClockFileRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 39.1666H3.00016C2.55814 39.1666 2.13421 38.991 1.82165 38.6784C1.50909 38.3659 1.3335 37.9419 1.3335 37.4999V2.49992C1.3335 2.05789 1.50909 1.63397 1.82165 1.32141C2.13421 1.00885 2.55814 0.833252 3.00016 0.833252H25.1552C25.3741 0.833517 25.5909 0.876929 25.7931 0.961005C25.9953 1.04508 26.1789 1.16818 26.3335 1.32325L32.5118 7.49992C32.8244 7.81241 33.0001 8.23626 33.0002 8.67825V14.1666",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1484 25.5448C12.7664 25.1687 11.5046 24.4429 10.4849 23.4372C9.46508 22.4315 8.72171 21.1799 8.32648 19.8033C7.93126 18.4266 7.89752 16.9714 8.22852 15.5779C8.55953 14.1844 9.2441 12.8997 10.2162 11.8479C11.1883 10.796 12.415 10.0124 13.7782 9.57276C15.1413 9.13309 16.5947 9.05217 17.9982 9.33781C19.4017 9.62344 20.7078 10.266 21.7907 11.2034C22.8735 12.1409 23.6965 13.3416 24.1801 14.6898",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 12.5017V17.5017H19.6668",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5003 30.835H19.667V36.6683",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6948 32.8899C38.0109 34.8951 36.6619 36.6062 34.8717 37.7392C33.0815 38.8722 30.9577 39.359 28.8528 39.1189C26.7478 38.8788 24.7882 37.9261 23.2992 36.419C21.8102 34.9119 20.8812 32.941 20.6665 30.8333",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8335 27.5015H39.6668V21.6682",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6387 25.4466C21.3224 23.4415 22.6711 21.7304 24.461 20.5972C26.2509 19.464 28.3745 18.9769 30.4793 19.2167C32.5842 19.4564 34.5438 20.4086 36.0331 21.9152C37.5223 23.4219 38.4517 25.3924 38.667 27.4999",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeClockFileRefresh);
export default __webpack_public_path__ + "static/media/time-clock-file-refresh.165723fc933df2f1000930f1b4935065.svg";
export { ForwardRef as ReactComponent };